<template>
  <div class="d-sm-flex bg-primary justify-content-sm-between mb-3 p-2 text-white shadow">
    <p class="small mb-0">
      <b class="d-block" v-translate>Destinations: </b> {{ destinations }}
    </p>
    <p class="small mb-0">
      <b class="d-block" v-translate>Areas: </b> {{ areas }}
    </p>
    <p class="small mb-0">
      <b class="d-block" v-translate>Categories: </b> {{ categories }}
    </p>
    <p class="small mb-0">
      <b class="d-block" v-translate>Departure points: </b> {{ departure_points }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    result: {
      type: Object,
      required: true
    }
  },
  computed: {
    destinations () {
      return this.result.destinations.map(el => el.name).join(', ')
    },
    areas () {
      return this.result.areas.map(el => el.name).join(', ')
    },
    categories () {
      return this.result.categories.map(el => el.name).join(', ')
    },
    departure_points () {
      return this.result.departure_points.map(el => el.name).join(', ')
    }
  }
}
</script>
